import React, {Component} from 'react'
import { withStyles } from '@material-ui/core/styles'
import { Grid } from '@material-ui/core'
import styles from './styles'
import {contentData} from './content'
import BasicView from '../../../../components/Layouts/BasicView/BasicView'
import GeneralView from './GeneralView/GeneralView'
import {request_insurance_carrier} from './requests'

class InsuranceCarrierView extends Component{

  state = {
    isloading:false,
    insurance_carrier:null
  }

  componentDidMount(){
    this.initModule()
  }

  initModule = async() => {
    const {match} = this.props
    const id = match.params.id
    this.setState({isloading:true})
    let response = await request_insurance_carrier(id)
    this.setState({insurance_carrier:{...response}})
    this.setState({isloading:false})
  }

  onEditUser = async() => {
    const {match,history} = this.props
    const id = match.params.id
    history.push('/catalogs/insurance_carriers/'+id+'/edit')
  }

  onReturn = () => {
    const {history} = this.props
    history.push('/catalogs/insurance_carriers')
  }


  render(){

    const { history, language,translations, user_level} = this.props
    const {insurance_carrier} = this.state
    const content = contentData[language]
    
    return(
      <BasicView
        history={history}
        selected={0}
        onChange={this.onChangeView}
        content={content.layout}
        returnBtn={true}
        onReturn={this.onReturn}
      >
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <GeneralView
              user_level={user_level}
              language={language}
              insurance_carrier={insurance_carrier}
              translations={translations}
              onEdit={this.onEditUser}
            />
          </Grid>
        </Grid>
        
      </BasicView>
      
    )
  }
}

export default withStyles(styles)(InsuranceCarrierView)